import { EndpointSetting } from "@/constants/app/type";
import { TourState } from "../types";

export const callbackToursCategories: EndpointSetting['caller'] = (
  state: TourState,
  action: any,
  endpointName: any
) => {
  state.tours_categories.loading = false
  state.tours_categories.error = null
  state.tours_categories.success = true
  state.tours_categories.called = true

  const destinations = (action.payload?.destinations || []).map((des: any) => ({
    ...des,
    matchers: {
      name: 0,
      country: 0
    }
  }))

  const departures = (action.payload?.departures || []).map((des: any) => ({
    ...des,
    matchers: {
      name: 0,
      country: 0
    }
  }))

  const tours = Object.values(
    (action.payload?.tourCategories || [])
      .reduce((obj: any, tourCategory: any) => {
        obj[tourCategory.id] = tourCategory
        return obj
      }, {})
  )
    .map((des: any) => ({
      ...des,
      matchers: {
        name: 0
      }
    }))

  state.tours_categories.data = {
    ...action.payload,
    departures: departures,
    tourCategories: tours,
    destinations,
    searchToursResult: tours,
    searchDeparturesResult: departures || [],
    searchDestinationsResult: destinations || []
  }
}